var map = {
	"./0/Kambi/Config.resource.js": [
		22965,
		4206
	],
	"./0/Poker/Config.resource.js": [
		95302,
		9653
	],
	"./0/Spectate/Config.resource.js": [
		32998,
		1213
	],
	"./1/Kambi/Config.resource.js": [
		58306,
		2889
	],
	"./1/Poker/Config.resource.js": [
		30093,
		858
	],
	"./1/Spectate/Config.resource.js": [
		19731,
		1346
	],
	"./31/Kambi/Config.resource.js": [
		91885,
		9310
	],
	"./31/Poker/Config.resource.js": [
		36174,
		3987
	],
	"./31/Spectate/Config.resource.js": [
		92190,
		7131
	],
	"./58/Spectate/Config.resource.js": [
		44601,
		678
	],
	"./75/Kambi/Config.resource.js": [
		16453,
		1910
	],
	"./75/Spectate/Config.resource.js": [
		77430,
		5179
	],
	"./76/Kambi/Config.resource.js": [
		92624,
		6123
	],
	"./76/Spectate/Config.resource.js": [
		41157,
		4950
	],
	"./8/Poker/Config.resource.js": [
		17902,
		9261
	],
	"./8/Spectate/Config.resource.js": [
		49278,
		7413
	],
	"./81/Kambi/Config.resource.js": [
		37690,
		5321
	],
	"./81/Spectate/Config.resource.js": [
		33963,
		2788
	],
	"./84/Kambi/Config.resource.js": [
		50529,
		1146
	],
	"./84/Spectate/Config.resource.js": [
		44066,
		6547
	],
	"./86/Spectate/Config.resource.js": [
		23244,
		5369
	],
	"./87/Spectate/Config.resource.js": [
		73361,
		158
	],
	"./88/Spectate/Config.resource.js": [
		58790,
		919
	],
	"./89/Spectate/Config.resource.js": [
		35635,
		1244
	],
	"./90/Spectate/Config.resource.js": [
		37181,
		4554
	],
	"./91/Spectate/Config.resource.js": [
		39656,
		9749
	],
	"./92/Spectate/Config.resource.js": [
		51611,
		3124
	],
	"./94/Spectate/Config.resource.js": [
		32609,
		1438
	],
	"./95/Spectate/Config.resource.js": [
		43292,
		7833
	],
	"./96/Poker/Config.resource.js": [
		40577,
		9616
	],
	"./96/Spectate/Config.resource.js": [
		61887,
		7240
	],
	"./default/Kambi/Config.resource.js": [
		58764,
		2671
	],
	"./default/Spectate/Config.resource.js": [
		85249,
		3120
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 67362;
module.exports = webpackAsyncContext;